
import React from "react";
import fields from "../../json/LanguageFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const LanguageForm = ({ 
  values = {}, 
  errors, 
  handleChange, 
  handleSubmit, 
  loading, 
  title = "Create Language" 
}) => {
  const { formdata } = fields;
  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {formdata.map((field) => {
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}
       
       <FormSubmitButton
        label={`Create`}
        loading={loading}
        colSize="col-6"
        align="end"
      />
    </PageBody>
  );
};

export default LanguageForm;
